module.exports = __webpack_public_path__ + "f615bc8889f29e532637002b750c70ed.png";